import api from './api'
import { Sacado, SacadoRequest } from '@/types/sacado'
import { PageResponse } from '@/types/comum'

const BASE_URL = '/api/v1/sacados'

export const sacadoService = {
  listar: async (
    params: { busca?: string; page?: number; size?: number } = {}
  ): Promise<PageResponse<Sacado>> => {
    const sp = new URLSearchParams()
    sp.append('page', String(params.page ?? 0))
    sp.append('size', String(params.size ?? 100))
    if (params.busca) sp.append('busca', params.busca)
    return api.get<PageResponse<Sacado>>(`${BASE_URL}?${sp.toString()}`)
  },

  obter: async (id: string): Promise<Sacado> => api.get<Sacado>(`${BASE_URL}/${id}`),

  criar: async (request: SacadoRequest): Promise<Sacado> =>
    api.post<Sacado>(BASE_URL, request),

  atualizar: async (id: string, request: SacadoRequest): Promise<Sacado> =>
    api.put<Sacado>(`${BASE_URL}/${id}`, request),

  deletar: async (id: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`)
  },
}
